import { createFileRoute } from '@tanstack/react-router';
import { PrivacyPage } from '../../pages/PrivacyPage';
import { staticPageHead } from '../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/privacy')({
  head: () =>
    staticPageHead({
      path: '/privacy',
      title: 'Privacy Policy - AnyAPI',
      description:
        'How AnyAPI collects, uses, and protects your data, including request data, account information, and telemetry, and the choices you have.',
      crumb: 'Privacy Policy',
    }),
  component: PrivacyPage,
});
